import React from 'react';
import fr from 'facet-rest';
import { pickFunction } from 'Helpers/Affordances';
import VirtualAccountsSetupStepper from './VirtualAccountsSetupStepper';

const FormPicker = (props) => {
  return pickFunction(props.resource, {
    [fr.relationships.default.name]: () => {
      return (
        <VirtualAccountsSetupStepper {...props} />
      );
    },
  });
};

export default FormPicker;
